/* eslint-disable no-undef */
export const createPodeli = (cartWidget, cb) => {
  const scripts = document.querySelectorAll('#cart-podeli-scr')

  if (scripts.length > 0) return

  const CartScript = document.createElement('script')
  CartScript.src =
    'https://cdn.podeli.ru/New-Widgets/New-card-item/podeli-widget.js'
  CartScript.defer = true
  CartScript.id = 'cart-podeli-scr'

  CartScript.onload = function () {
    cartWidget.current = CartWidget
    cb()
  }

  document.body.appendChild(CartScript)
}
